export default __webpack_public_path__ + "static/media/backgroundMovil.eab8aa3e.png";